<template>
  <div class="fill-height">
    <v-card
        height="100%"
        class="d-flex flex-column rounded-lg"
    >
      <v-card-title class="primary white--text text-break"><strong>{{ $t('cards.titles.accountSetup') }}</strong></v-card-title>
      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-if="!isLoading" class="primary pb-10">
          <v-progress-linear
            color="success"
            rounded
            :value="accountProgress"
            height="16"
            dark
          >
            {{ accountProgress }}%
          </v-progress-linear>
      </v-card-text>
      <v-card-text v-if="!isLoading">
        <v-card
          class="rounded-lg mt-n10 mb-2"
          link
          @click.prevent="navigate('/profile')"
        >
          <v-card-text class="d-flex">
            <div class="mr-4">
              <v-icon small color="primary">fas fa-circle-check</v-icon>
            </div>
            <div><strong>{{ $t('labels.profile') }}</strong></div>
          </v-card-text>
        </v-card>
        <v-card
            :loading="connectionWatchLoading"
            class="rounded-lg mb-2"
            link
            @click.prevent="navigate('/connections/watch-on-the-go')"
        >
          <v-card-text class="d-flex">
            <div class="mr-4">
              <v-icon v-if="connectionWatch.vimeoConnected" small color="primary">fas fa-circle-check</v-icon>
              <v-icon v-else small color="primary">fal fa-circle</v-icon>
            </div>
            <div><strong>{{ $t('labels.watchOnTheGo') }}</strong></div>
          </v-card-text>
        </v-card>
        <v-card
                :loading="connectionWefitterLoading"
            class="rounded-lg mb-2"
            link
            @click.prevent="navigate('/connections/wearables')"
        >
          <v-card-text class="d-flex">
            <div class="mr-4">
                <v-icon v-if="connectionWefitter.wefitterConnected" small color="primary">fas fa-circle-check</v-icon>
                <v-icon v-else small color="primary">fal fa-circle</v-icon>
            </div>
            <div><strong>{{ $t('labels.wearables') }}</strong></div>
          </v-card-text>
        </v-card>
        <v-card
            :loading="connectionWefitterLoading"
            class="rounded-lg mb-2"
            link
            @click.prevent="navigate('/connections/bio-age')"
        >
          <v-card-text class="d-flex">
            <div class="mr-4">
              <v-icon v-if="connectionWefitter.wefitterBioAgeConnected" small color="primary">fas fa-circle-check</v-icon>
              <v-icon v-else small color="primary">fal fa-circle</v-icon>
            </div>
            <div class="text-uppercase"><strong>{{ $t('labels.bio-age') }}</strong></div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-account-setup",
  data() {
    return {
      isLoading: false,
      connectionWatch: {},
      connectionWatchLoading: false,
      connectionWefitter: {},
      connectionWefitterLoading: false
    }
  },
  
  computed: {
    accountProgress(){
      let score = 0
      // add 1 if vimeo is connected
      if (this.connectionWatch && this.connectionWatch.vimeoConnected){ score++ }
      if (this.connectionWefitter && this.connectionWefitter.wefitterConnected){ score++ }
      // add 1 for profile
      score++
      
      return ((score / 3) * 100).toFixed(0)
    }
  },

  mounted(){
    this.fetchConnectionWatch()
    this.fetchConnectionWefitter()
  },

  methods: {
    async fetchConnectionWatch() {
      const that = this
      that.connectionWatchLoading = true
      await api.connections.getWatchOnTheGo()
          .then((res) => {
            that.connectionWatch = res.data
            that.connectionWatchLoading = false
          })
    },

    async fetchConnectionWefitter() {
        const that = this
        that.connectionWefitterLoading = true
        await api.connections.getWefitterStatus()
            .then((res) => {
                that.connectionWefitter = res.data
                that.connectionWefitterLoading = false
            })
    },
    
    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    }
  }
}
</script>

<style scoped>

</style>
